<template>
  <b-modal
    :id="modalId"
    ref="modalFontAwesome"
    :title="$t('engine.modal.fontAwesome.lblTitle', languageEngine)"
    title-class="fs-db-28"
    header-class="align-items-center px-gd-3 py-gd-2"
    footer-class="align-items-center px-gd-3 py-gd-2"
    body-class="p-0"
    size="lg"
    @hidden="onModalHidden"
    @shown="onModalShown"
    @show="onModalShow"
  >
    <div class="modal-body-wrapper" :style="cssVars">
      <div class="category-container">
        <div class="category-item" :class="{'active': categoryActiveId == cate.id}" v-for="cate in categoryList" :key="`cate_${cate.id}`" @click="selectCategory(cate.id)">
          <div class="category-text fs-sa-16">{{cate.name}}</div>
        </div>
      </div>
      <div class="icon-container">
        <div class="search-wrapper d-flex align-items-center position-relative">
          <span
            style="cursor: pointer; position: absolute; left: 10px"
            @click="getFontAwesomes"
          >
            <i class="far fa-search text-muted"></i
          ></span>
          <b-form-input
            class="search px-gd-4"
            v-model="textSearch"
            @keyup.enter.native="getFontAwesomes"
            :placeholder="$t('engine.modal.fontAwesome.lblSearchPlaceholder', languageEngine)"
            :disabled="loading"
          />
          <span
            v-if="textSearch"
            style="cursor: pointer; position: absolute; right: 10px"
            @click="textSearch = undefined"
          >
            <i class="fas fa-times-circle text-muted"></i>
          </span>
        </div>
        <div id="fawes-icon-list-wrapper" class="icon-list-wrapper mt-gd-4">
          <span class="spinner-border spinner-border-xl spinner-loading" role="status" aria-hidden="true" v-if="loading"></span>
          <div id="inner-list-wrapper" class="inner-list-wrapper" v-if="!loading && iconList.length > 0">
            <div class="icon-item" :class="{'active': iconSelectedId == icon.id}" v-for="icon in iconList" :key="`icon_${icon.id}`" @click="(e) => selectIcon(icon, e)">
              <i :class="icon.class"/>
            </div>
          </div>
          <div class="no-icon text-center fs-sa-16" v-if="!loading && iconList.length == 0">{{$t('engine.modal.fontAwesome.lblIconNotFound', languageEngine)}}</div>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <b-button
        variant="blue"
        class=""
        :disabled="!iconSelectedId"
        @click="onSubmit"
      >
        <i class="far fa-check"></i> {{$t('engine.common.btnSelect', languageEngine)}}
      </b-button>
      <b-button variant="default" @click="closeModal">
        <i class="far fa-times"></i>
        {{$t('engine.common.btnCancel', languageEngine)}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import fontAwesomeService from "@services/fontAwesomeService.js";

export default {
  data() {
    return {
      modalId: "modal-fontawesome",
      loading: false,
      totalCountIcon: 0,
      iconList: [],
      totalCountCategory: 0,
      categoryList: [],
      categoryActiveId: 0,
      textSearch: undefined,
      iconSelectedId: undefined,
      iconSelectedData: undefined,
      iconSelectedHtml: undefined,
      iconGap: 32,
    };
  },
  computed: {
    ...mapGetters({
      modals: "design/modals/modals",
      modalActive: "design/modals/modalActive",
      languageEngine: "design/userPreference/languageEngine",
    }),
    categoryListDefault() {
      return [
        {
          id: "0",
          name: this.$t('engine.common.lblAll', this.languageEngine),
          order: "0",
          isEnable: "1",
          dateCreate: "0000-00-00 00:00:00"
        }
      ]
    },
    cssVars() {
      return {
        '--iconlist-gap': this.iconGap + 'px'
      }
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
    onModalHidden() {
      this.$store.dispatch("designIframe/modals/callback", {
        key: this.modalId,
        clear: true,
        func: 'onClose',
        data: {}
      },{ root:true });
      this.iconList = [];
    },
    onSubmit() {
      if (!this.iconSelectedData || !this.iconSelectedHtml) return
      this.$store.dispatch("designIframe/modals/callback", {
        key: this.modalId,
        clear: false,
        func: 'onSubmit',
        data: {
          icon: {
            data: this.iconSelectedData,
            html: this.iconSelectedHtml
          }
        },
      },{ root:true });
      this.closeModal()
    },
    onModalShown() {
      this.clear()
      this.getFontAwesomeCategories()
      this.getFontAwesomes()
    },
    onModalShow() {
      this.setIconGap()
    },
    async getFontAwesomes() {
      this.loading = true
      const data = {
        categoryId: this.categoryActiveId,
        textSearch: this.textSearch,
        language: this.languageEngine,
      };
      await fontAwesomeService.getFontAwesomes(data).then((response) => {
        this.totalCount = response.totalCount
        this.iconList = response.data
      })
      this.loading = false
    },
    async getFontAwesomeCategories() {
      const data = {
        language: this.languageEngine,
      };
      await fontAwesomeService.getFontAwesomeCategories(data).then((response) => {
        this.totalCountCategory = response.totalCount
        this.categoryList = [...this.categoryListDefault, ...response.data]
      })
    },
    selectCategory(categoryId) {
      this.categoryActiveId = categoryId
      this.getFontAwesomes()
    },
    selectIcon(icon, e) {
      this.iconSelectedId = icon.id
      this.iconSelectedData = icon
      let elIcon = e.target
      let contentSvg = elIcon.innerHTML.split('</svg>')[0] + '</svg>'
      this.iconSelectedHtml = contentSvg
    },
    clear() {
      this.totalCountIcon = 0,
      this.iconList = [],
      this.totalCountCategory = 0,
      this.categoryList = [],
      this.textSearch = undefined,
      this.categoryActiveId = 0
      this.iconSelectedId = undefined
      this.iconSelectedData = undefined
      this.iconSelectedHtml = undefined
    },
    setIconGap() {
      function setGap(wrapperWidth) {
        let iconWidth = 32
        let minGap = 32
        let _wrapperWidth = Math.floor(wrapperWidth)
        if ((iconWidth + minGap) * 12 <= (_wrapperWidth + minGap)) {
          return Math.floor((_wrapperWidth - 8 - (iconWidth * 12)) / 11)
        } else {
          let numIconPerRow = Math.floor(_wrapperWidth / (iconWidth + minGap))
          return Math.floor((_wrapperWidth - 8 - (iconWidth * numIconPerRow)) / (numIconPerRow - 1))
        }
      }
      let a = 0;
      let myInterval = setInterval(() =>{
        let wrapper = document.getElementById('fawes-icon-list-wrapper')
        if (wrapper) {
          let wrapperWidth = wrapper.getBoundingClientRect().width
          this.iconGap = setGap(wrapperWidth)
          this.resizeObserver = new ResizeObserver(() => {
            let wrapperWidth = wrapper.getBoundingClientRect().width
            this.iconGap = setGap(wrapperWidth)
          }).observe(wrapper);
          clearInterval(myInterval);
        }
        if(a >= 1000) {
          clearInterval(myInterval);
        }
        a = a + 1;
      }, 150);
    }
  },
  watch: {
    modalActive: {
      handler(next) {
        if(next == this.modalId) {
          this.$bvModal.show(this.modalId);
        }
      },
    },
    iconList: {
      handler() {
        this.setIconGap()
      },
    },
  },
};
</script>

<style lang="scss">
/* 
- Modal Max Height  800px
- Modal Width = Auto โดยมี Min width = 600px , Max Width  1,364px และไม่ชนขอบ Browser เว้น Padding อย่างน้อย 30px 
- Icon max 12 column , gap auto , min gap 32px 
*/
#modal-fontawesome {
  height: 100vh;
  .modal-dialog {
    height: 100%;
    max-height: 860px;
    max-width: 1424px;
    min-width: 660px;
    margin: auto;
    padding: 30px;
  }
  .modal-content {
    /* height: calc(100vh - 3.5rem); */
    height: 100%;
    max-height: 800px;
  }
  .modal-body {
    height: calc(100% - 126px);
    /* height: 100%; */
    padding: 0;
    .modal-body-wrapper{
      height: 100%;
      display: flex;
      .category-container {
        width: 20%;
        padding: 16px;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        &::-webkit-scrollbar-track {
          background-color: transparent;
        }
        &::-webkit-scrollbar-thumb {
          background: #babac0;
          border-radius: 6px;
        }
        &::-webkit-scrollbar-track-piece:end {
            background: transparent;
            margin-bottom: 4px; 
        }
        &::-webkit-scrollbar-track-piece:start {
            background: transparent;
            margin-top: 4px; 
        }
        .category-item {
          padding: 8px 16px;
          cursor: pointer;
          &:hover, &.active {
            background-color: #edfaff;
            border-radius: 4px;
          }
        }
      }
      .icon-container {
        width: 80%;
        position: relative;
        padding: 16px;
        border-left: 1px solid #DEE3E6;
        display: flex;
        flex-direction: column;
        .icon-list-wrapper {
          height: calc(100% - 64px);
          .inner-list-wrapper {
            /* height: calc(100% + 8px); */
            max-height: 100%;
            display: flex;
            flex-wrap: wrap;
            gap: var(--iconlist-gap);
            overflow: auto;
            overscroll-behavior: contain;
            margin: -8px -12px 0 -8px;
            padding: 8px 8px 10px 8px;
            &::-webkit-scrollbar {
              width: 6px;
              height: 6px;
            }
            &::-webkit-scrollbar-track {
              background-color: transparent;
            }
            &::-webkit-scrollbar-thumb {
              background: #babac0;
              border-radius: 6px;
            }
            &::-webkit-scrollbar-track-piece:end {
                background: transparent;
                margin-bottom: 4px; 
            }
            &::-webkit-scrollbar-track-piece:start {
                background: transparent;
                margin-top: 4px; 
            }
            .icon-item {
              width: 32px;
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              i, svg {
                font-size: 30px;
              }
              &:hover {
                &::after {
                  content: "";
                  width: 48px;
                  height: 48px;
                  /* background-color: #e3ecf0; */
                  background-color: transparent;
                  border: solid 4px #bababa;
                  position: absolute;
                  top: -8px;
                  left: -8px;
                  border-radius: 4px;
                }
              }
              &.active {
                &::after {
                  content: "";
                  width: 48px;
                  height: 48px;
                  background-color: transparent;
                  border: solid 4px var(--primary);
                  position: absolute;
                  top: -8px;
                  left: -8px;
                  border-radius: 4px;
                }
              }
            }
          }
        }
      }
    }
  }
  .spinner-loading {
    position: absolute;
    top: calc(50% - 2rem);
    left: calc(50% - 2rem);
  }
}
</style>


